import React from "react";

interface InfoRowProps {
  label: string;
  value: string;
  isLink?: boolean;
  onRequestChange?: () => void;
  requestSent?: boolean;
  requestLoading?: boolean;
}

const InfoRow: React.FC<InfoRowProps> = ({
  label,
  value,
  isLink = false,
  onRequestChange,
  requestSent = false,
  requestLoading = false,
}) => (
  <div className="py-4 border-b border-[#f0f3fa] last:border-0">
    <div className="text-dark-blue mb-1 text-[13px] font-medium font-primary">
      {label}
    </div>

    <div className="flex items-center justify-between gap-4">
      <div
        className={`truncate text-[15px] font-medium font-primary ${
          isLink ? "text-blue" : "text-[#26295e]"
        }`}
      >
        {value}
      </div>

      {onRequestChange && (
        <button
          type="button"
          onClick={onRequestChange}
          disabled={requestSent || requestLoading}
          className={`flex-shrink-0 px-1 md:px-4 py-4 border-2 font-primary text-[13px] rounded-lg text-sm font-medium transition-all duration-200 flex-nowrap
            ${
              requestSent
                ? "border-success text-success cursor-not-allowed opacity-70"
                : requestLoading
                  ? "border-[#3b519c] text-[#3b519c] opacity-50 cursor-not-allowed"
                  : "border-[#3b519c] text-[#000] hover:bg-[#3b519c] hover:text-white cursor-pointer"
            }`}
        >
          {requestLoading
            ? "Sending..."
            : requestSent
              ? "Request Sent"
              : "Request Change"}
        </button>
      )}
    </div>
  </div>
);

export default InfoRow;
